export default function setProductTabs() {
  const sections = document.querySelectorAll('.product-description');

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('[data-tabs] .titulo');
    const contentsWrapper = section.querySelectorAll('.content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();

        const tabMobile = tab.closest('.wrapper-tab-mobile');

        const id = tab.getAttribute('data-content');
        const content = section.querySelector(id);

        // remove o active de todas as tabs
        tabs.forEach((checkTab) => {
          checkTab.classList.remove('-active');

          const tabMobile = checkTab.closest('.wrapper-tab-mobile');
          if (tabMobile) tabMobile.classList.remove('-active');
        });
        contentsWrapper.forEach((checkContent) => checkContent.classList.remove('-active'));

        // adiciona active na tab clicada
        tab.classList.add('-active');
        if (tabMobile) tabMobile.classList.add('-active');
        content.classList.add('-active');
      });
    });
  });
}
